<template>
    <div class="page" :class="{isPhonePage: isPhone}">
        <img src="http://img.cdboost.cn/cdboost/sy/gywm01.jpg" alt="" style="width: 100%;height:27.5625rem">
        <div class="box1" id="ID41">
            <div>
                <div class="box2">
                    <p>成都博高电管家科技有限公司(下称“博高电管家“)&nbsp是成都博高信息技术股份有限公司下属专业从事电动自行车无人值守业务，充换电业务和新能源汽车有序充电业务的子公司，致力于成为国内一流的创新型安全用电管理专家方案提供商。</p>
                    <p>博高电管家传承博高信息20多年用电安全的产品设计，系统开发经验，专业打造安全有序充电，无人值守的整体解决方案。该方案采用国际标准物联网通信技术、云计算、大数据以及Ai人工智能算法，能够有效解决停车被盗、充电消防安全等社会痛点。</p>
                </div>
                <div class="box3">
                    <p>母公司博高信息是一家专业从事智能电网行业用电信息采集领域的软件开发，设备制造和产品销售的高新技术企业。</p>
                    <p>博高信息是国际和国内LoRaWAN联盟成员，拥有国内最早从事LoRa技术研发的团队，是国内第一家利用LoRaWAN技术实现规模化应用的厂商，是国内领先的物联网整体解决方案提供商。</p>
                </div>
            </div>
            <div class="box4">
                <img src="http://img.cdboost.cn/cdboost/sy/about01.png" alt="" class="pic1"><p style="color: #0065ad;font-size: 3.125rem;font-weight: bold;">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp企业简介</p>
            </div>
        </div>
        <div class="ex">
            <span style="display: flex;justify-content: center;font-size: 3rem;font-weight: bold"><br>企业历程</span>
        </div>
        <div class="cult" id="ID42"></div>
        <div class="qual" id="ID43"></div>
        <div class="lab" id="ID44"></div>
<!--        <div class="lab"  id="ID44">-->
<!--            <div class="lab1">-->
<!--                <img src="http://img.cdboost.cn/cdboost/sy/lab1.png" alt="" style="width: 26.875rem;height: 39.9375rem">-->
<!--                <div style="flex-direction: column;font-size: 2.25rem">-->
<!--                    <br>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp高温实验室-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="lab2">-->
<!--                <div class="lab3">-->
<!--                    <div>-->
<!--                        <img src="http://img.cdboost.cn/cdboost/sy/lab2.png" alt="" style="width: 34.375rem;height: 18.75rem">-->
<!--                    </div>-->
<!--                    <div>-->
<!--                        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp芯片烧写-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="lab3">-->
<!--                    <div>-->
<!--                        <img src="http://img.cdboost.cn/cdboost/sy/lab3.png" alt="" style="width: 34.375rem;height: 18.75rem">-->
<!--                    </div>-->
<!--                    <div>-->
<!--                        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp计量校验实验室-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="lab3">-->
<!--                    <div>-->
<!--                        <img src="http://img.cdboost.cn/cdboost/sy/lab4.png" alt="" style="width: 34.375rem;height: 18.75rem">-->
<!--                    </div>-->
<!--                    <div>-->
<!--                        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp电磁兼容实验室-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="lab3">-->
<!--                    <div>-->
<!--                        <img src="http://img.cdboost.cn/cdboost/sy/lab5.png" alt="" style="width: 34.375rem;height: 18.75rem">-->
<!--                    </div>-->
<!--                    <div>-->
<!--                        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp环境实验室-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div style="flex: 1">-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>
    import {getPCorPhone} from "../tools";

    export default {
        name: "about",
        data(){
            return {
                isPhone: false,
            }
        },
        created() {
            this.isPhone = getPCorPhone();
        }
    }
</script>
<style scoped  lang="scss">
    .base {
        color: #333333;
        position: relative;
        overflow: hidden;
        background: white;
    }
    .page{
        overflow: hidden;
    }
    .box1 {
        position: relative;
        background: #DFE8EF;
        width: 100%;
        display: flex;
        align-items: center;
        p{
            text-indent: 2em;
        }
    }

    .box2 {
        color: #333333;
        position: relative;
        background: #DFE8EF;
        font-size: 1.875rem;
        padding: 1.875rem;
        line-height: 3.75rem;
        width: calc(100% - 1.875rem * 2);
    }
    .box3 {
        color: #666666;
        position: relative;
        background: #DFE8EF;
        font-size: 1.875rem;
        line-height: 3.75rem;
        padding-bottom: 7rem;
        margin-left: 1.5625rem;
        margin-right: 1.5625rem;
        width: 65%;
    }
    .box4 {
        grid-area: 1 / 2 / 3 / 3;
        margin-top: 3.125rem;
        position: absolute;
	    right: 1%;
	    bottom: 0;
	    .pic1 {
		    width:30rem;
		    height:28rem;
	    }
    }
    .lab {
        display: flex;
        position: relative;
        width: 100%;
        height: 55rem;
        background-image: url("http://img.cdboost.cn/cdboost/sy/gywm06.jpg");
        background-size: 100% 100%;
    }
    .lab1 {
        color: #666666;
        flex:5;
        display: flex;
        margin-left: 6.25rem;
        margin-top: 11.25rem;
        flex-direction: column;
    }
    .lab2 {
        color: #666666;
        flex:12;
        display: flex;
        margin-top: 11.25rem;
        flex-wrap: wrap;
        justify-content: space-around;
    }
    .lab3 {
        display: flex;
        flex-direction: column;
        font-size: 2.25rem;
    }
    .ex {
        color: #3b70b2;
        position: relative;
        width: 100%;
        height: 55rem;
        background-image: url("http://img.cdboost.cn/cdboost/sy/gywm03.jpg");
        background-size: 100% 100%;
    }
    .cult {
        color: #3b70b2;
        position: relative;
        width: 100%;
        height: 55rem;
        background-image: url("http://img.cdboost.cn/cdboost/sy/gywm04.jpg");
        background-size: 100% 100%;
    }
    .qual {
        color: #d8b575;
        position: relative;
        width: 100%;
        height: 55rem;
        background-image: url("http://img.cdboost.cn/cdboost/sy/gywm05.jpg");
	    background-size: 100% 100%;
    }
    .isPhonePage{
        #ID41{
            div{
                font-size: 12px;
            }
        }
    }
</style>


